let BASE_URL = ''
const TIME_OUT = 60000
if (process.env.NODE_ENV === 'development') {
  BASE_URL = '/api'
} else if (process.env.NODE_ENV === 'production') {
  BASE_URL = 'https://yuanyuancy.com/houRes'
} else {
  BASE_URL = 'http://xxxxxxx/test'
}
export { TIME_OUT, BASE_URL }
